import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScBenefitsSection = styled.section`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (${device.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${device.mobile}) {
    margin-top: 16px;
  }

  @media (${device.mobileS}) {
    grid-template-columns: 1fr;
    margin-top: 16px;
  }

  @media (${device.mobileXS}) {
    margin-top: 16px;
  }
`;
